import React from 'react';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
interface BlogCardProps {
  title: string;
  excerpt: string;
  slug: string;
  date: string;
  readTime: string;
}
export function BlogCard({
  title,
  excerpt,
  slug,
  date,
  readTime
}: BlogCardProps) {
  return <a href={`/blog/${slug}`} onClick={e => {
    e.preventDefault();
    window.history.pushState({}, '', `/blog/${slug}`);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
  }} className="group flex flex-col h-full bg-[#0a0a0a] border border-white/[0.06] rounded-xl overflow-hidden hover:border-[#c9a84c]/40 transition-all duration-300" data-id="element-67">
      <div className="p-6 flex flex-col flex-1" data-id="element-68">
        <div className="flex items-center space-x-4 text-xs text-white/40 mb-4" data-id="element-69">
          <div className="flex items-center space-x-1" data-id="element-70">
            <Calendar className="w-3 h-3" data-id="element-71" />
            <span data-id="element-72">{date}</span>
          </div>
          <div className="flex items-center space-x-1" data-id="element-73">
            <Clock className="w-3 h-3" data-id="element-74" />
            <span data-id="element-75">{readTime}</span>
          </div>
        </div>

        <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#c9a84c] transition-colors" data-id="element-76">
          {title}
        </h3>

        <p className="text-white/60 text-sm leading-relaxed mb-6 flex-1" data-id="element-77">
          {excerpt}
        </p>

        <div className="flex items-center text-[#c9a84c] text-sm font-medium mt-auto" data-id="element-78">
          <span data-id="element-79">Read Article</span>
          <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-80" />
        </div>
      </div>
    </a>;
}